module.exports = __webpack_public_path__ + "images/60008e388f28329aaf2ea4559470cec3.png";